import * as React from 'react';

import { Autocomplete, Button, FormControl, Stack, TextField } from '@mui/material';
import { Modal } from './Modal';

import PeopleIcon from '@mui/icons-material/People';
import { IErrorInfo } from '../ErrorAlert';
import { useLocation } from 'react-router-dom';
import { getQueryRunner, httpGet, httpPost } from '../Web';

interface WorkshopUser {
    id: number,
    workshopId: number,
    status: number
}

export const TransferRegistrationModal = () => {
    const [fromRegistrations, setFromRegistrations] = React.useState<any[]>([]);
    const [toRegistrations, setToRegistrations] = React.useState<any[]>([]);
    const [toError, setToError] = React.useState<IErrorInfo | null>(null);
    const [fromError, setFromError] = React.useState<IErrorInfo | null>(null);

    const [fromSelected, setFromSelected] = React.useState<WorkshopUser>();
    const [toSelected, setToSelected] = React.useState<any>();

    const pageLocation = useLocation();
    const {workshopId} = pageLocation.state;
    
    React.useEffect(getQueryRunner(`api/workshop/user/${workshopId}`, setFromRegistrations, setToError), []);
    React.useEffect(getQueryRunner('api/user', setToRegistrations, setFromError), []);

    const onSubmitHandler = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        httpGet(`api/workshop/user/delete/${fromSelected?.id}`, new AbortController())
            .then((value)=>{httpPost(`api/workshop/user/update/`, {userId: toSelected.userId, workshopId: fromSelected?.workshopId, status: fromSelected?.status}, new AbortController()).then(result => console.log(result))});
    }

    return <Modal title={"Transfer Registration"} description={"Transfer Registration to another User"}
        cancel buttons={[<Button type='submit' form='transferForm' startIcon={<PeopleIcon />}>{"Transfer registration"}</Button>]}>
        <Stack spacing={20}>
            <form id="transferForm" onSubmit={onSubmitHandler}>
                <Stack direction='row' spacing={10}>
                    <FormControl fullWidth>
                        <Autocomplete
                            options={fromRegistrations}
                            renderInput = {
                                (params) => <TextField multiline {...params} label={"From:"}/>
                            }
                            getOptionLabel={(option) => `${option.name}, ${option.companyName}`}
                            onChange={(event, value, reason) => { setFromSelected({id: value.id, workshopId: value.workshopId, status: value.status});}} 
                        />
                    </FormControl>
                    
                    <FormControl fullWidth>
                        <Autocomplete
                            options={toRegistrations}
                            renderInput = {
                                (params) => <TextField multiline {...params} label={"To:"}/>
                            }
                            getOptionLabel={(option) => `${option.name}, ${option.companyName}`}
                            onChange={(event, value, reason) => { setToSelected({userId: value.id});}} 
                        />
                    </FormControl>
                </Stack>
            </form>
        </Stack>
    </Modal>
}